/* eslint-disable */
import { apiRequest } from '@/calls/helpers';

const like = async ({ event, user, pref, remove }) => {
  try {
    const request = await apiRequest('like.php', {
      event, user, pref,
      remove_like: remove
    });

    return {
      success: true,
      error: false,
      data: {
        liked: true
      }
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getLikes = async (event) => {
  try {
    const request = await apiRequest('likes.php', { event });

    return {
      success: request.success,
      error: request.success ? false : true,
      data: request.success ? request.total : null
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

export {
  // eslint-disable-next-line
  like,
  getLikes
};
